import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-wartungsbericht-lkt-bioclear-vario',
  templateUrl: './form-wartungsbericht-lkt-bioclear-vario.component.html',
  styleUrls: ['./form-wartungsbericht-lkt-bioclear-vario.component.scss'],
})
export class FormWartungsberichtLktBioclearVarioComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() anlagenreihe: string;

  ngOnInit() {}
}
